// extracted by mini-css-extract-plugin
export default {"Stenth":"Stenth_Stenth__Glntj","wrap":"Stenth_wrap__lNpUp","text":"Stenth_text__nZwH-","title":"Stenth_title__q1UNM","desc":"Stenth_desc__xr1OL"};